<template>
  <div>
    <v-card>
      <v-container class="pb-0">
        <v-layout>
          <v-flex xs12 class="text-center">
            <span class="title text-capitalize"> {{ comida.nombre.toLowerCase() }}</span>
            <v-divider></v-divider>
          </v-flex>
        </v-layout>
      </v-container>
      <v-card-title class="py-0">
        <v-expansion-panel popout class="mb-0">
          <v-expansion-panel-content>
            <template v-slot:actions>
              <v-icon color="primary"></v-icon>
            </template>
            <template v-slot:header class="py-0">
              <v-icon color="primary">$vuetify.icons.expand</v-icon>
            </template>
            <v-card>
              <v-card-text>
                <ul>
                  <li v-for="(d, dinx) in prepararDescripcion(comida.descripcion)" :key="`des-c-${dinx}`">
                    <span class="caption">
                      {{ d }}
                    </span>
                  </li>
                </ul>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-card-title>
      <v-card-text class="pa-0">
        <v-container grid-list-md text-xs-center class="pa-0">
          <v-layout row wrap justify-space-around>
            <v-flex xs6 v-for="(t, cinx) in limpiarTarifas(comida.tarifas.tarifa)" :key="`comida-${cinx}`">
              <p class="mb-0 font-weight-bold green--text darken-4">
                {{ t.moneda }} {{ t.venta / t["@attributes"].pax }}
              </p>
              <p class="caption font-weight-light" v-if="t['@attributes'].tipo == 'adl'">
                Precio por adulto
              </p>
              <p class="caption font-weight-light" v-if="t['@attributes'].tipo == 'chd'">
                Precio por menor
              </p>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-btn block color="success" v-if="isSeleccionado">
          <v-icon small>
            fas fa-check
          </v-icon>
        </v-btn>
        <v-btn block color="primary" @click="agregarComida" v-else>
          SELECCIONAR
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
export default {
  name: "panelComida",
  props: {
    comida: {
      type: Object,
      default: function() {
        return {}
      }
    },
    comparador: {
      type: String,
      default: function() {
        return null
      }
    }
  },
  components: {},
  mounted() {},
  beforeCreate() {},
  methods: {
    prepararDescripcion(descripcion) {
      if (descripcion === undefined) {
        return ""
      }
      const filtrados = descripcion
        .split("\n")
        .map(e => e.trim())
        .filter(d => {
          if (d.length === 0) {
            return false
          }
          return true
        })
      return filtrados
    },
    limpiarTarifas(crudo) {
      const limpios = this.toArray(crudo).filter(c => c["@attributes"].tipo != "total")
      return limpios
    },
    async agregarComida() {
      const agregado = await this.$store.dispatch("carrito/agregarComida2Habitacion", {
        comida: this.comida,
        comparador: this.comparador
      })
      if (!agregado) {
        this.showToasted("El plan no fue agregado al carrito, por favor pruebe nuevamente", "success")
      }
      this.showToasted("El plan fue agregado al carrito", "success")
      this.$store.commit("carrito/setOpen", true)
    },
    isInHabitacion() {
      let _this = this
      const indice = this.servicios.hoteles.findIndex(h => {
        try {
          const indice = h.habitaciones
            .find(hab => hab.habitacion.comparador === _this.comparador)
            .habitacion.comidas.findIndex(c => _this.comida["@attributes"].id === c["@attributes"].id)
          return indice === -1 ? false : true
        } catch (e) {
          //console.log(e);
          return false
        }
      })
      return indice === -1 ? false : true
    }
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters("carrito", {
      servicios: "cartServicios"
    }),
    isSeleccionado() {
      return this.isInHabitacion()
    }
  }
}
</script>
